import { render, staticRenderFns } from "./ReferralCodes.vue?vue&type=template&id=b97c1f42&"
import script from "./ReferralCodes.vue?vue&type=script&lang=js&"
export * from "./ReferralCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports